import React, {Component} from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

export class FaIcon extends Component {
    getExtraClassName() {
        if (this.props.className) {
            return this.props.className;
        }

        return "";
    }

    render() {
        return <FontAwesomeIcon className={'icon ' + this.props.className + ' ' + this.getExtraClassName()}
                                icon={[this.prefix(), this.props.iconName]}
                                spin={this.props.spin}
                                style={this.props.style}
        />
    }

    prefix() {
        if (this.props.prefix === undefined) {
            return 'fas'
        } else {
            return this.props.prefix
        }
    }
}
